import React, { useState, useEffect } from "react";
import TabsComponent from "../../Components/Categories/TabsComponent/TabsComponent";
import ServiceProvidersForPackage from "../../Components/ServiceProvidersForPackage/ServiceProvidersForPackage";
import styles from "../../Components/ServiceProviders/ServiceProviders.module.css";
import SearchComponent from "../../Components/Utilities/SearchComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getAllServiceproviders } from "../../redux/Slices/Services/thunk";
import { useTranslation } from "react-i18next";

const ServiceProvidersForPackagePage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const location = useLocation();
  const {
    selectedPackageService,
    header2,
    header,
    ServiceStatus,
    isEdit,
    startDateFromEdit,
    servicesId,
    servicesId2,
    service
  } = location.state || {}; // Get card data from navigation state
  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log("header2", header2);
  console.log("header", header);
  console.log("ServiceStatus", ServiceStatus);
  let numberId;
  if (isEdit) {
    numberId = Number(servicesId);
  } else {
    numberId = Number(selectedPackageService?.itd_itmsrl);
  }
  console.log("selectedPackageService", selectedPackageService);

  useEffect(() => {
    if (numberId) {
      dispatch(getAllServiceproviders({ serviceId: numberId }));
    }
  }, [numberId, dispatch]);

  return (
    <div className="flex-grow-1">
      <div className={styles.loginContainer}>
        <div className={styles.loginHeader}>{t("service_providers")}</div>
        <div className={styles.loginSecHeader}>
          {t("service_providers_description")}
        </div>
      </div>

      <ServiceProvidersForPackage
        selectedPackageService={selectedPackageService}
        header={header}
        header2={header2}
        ServiceStatus={ServiceStatus}
        isEdit={isEdit}
        startDateFromEdit={startDateFromEdit}
        service={service}
        servicesId2={servicesId2}
      />
    </div>
  );
};
export default ServiceProvidersForPackagePage;
